import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { Maybe } from '@/utils/types';
interface Props {
  rows?: Maybe<Array<{
    cells?: Maybe<Array<Maybe<string>>>;
  } | null>>;
}
export function EshopTable(props) {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.rows) {
    t0 = props.rows?.map(_temp2);
    $[0] = props.rows;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <table className="mt-6 mb-16 w-full border-collapse"><tbody>{t0}</tbody></table>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp2(row, i) {
  return <tr key={i} className="mb-2 grid w-full rounded-lg bg-blue-100 px-4 py-3 lg:mb-0 lg:table-row lg:rounded-none lg:bg-transparent lg:px-0 lg:py-0">{row?.cells?.map(_temp)}</tr>;
}
function _temp(cell, j) {
  return <td className={mergeClasses("border-x-0 lg:border-y-8 lg:border-blue-50 lg:bg-blue-100 lg:px-4 lg:py-3", j === 0 && "font-semibold lg:max-w-12 lg:min-w-32 lg:rounded-tl-2xl lg:rounded-bl-2xl", j === 1 && "lg:rounded-tr-2xl lg:rounded-br-2xl")} key={j}>{cell}</td>;
}